module.exports = __webpack_public_path__ + "img/marble-bkg.8287e74e.jpg";